export default class ApiObject {

  /**
   * Unwrap the JSON payload and return its data attribute.
   * @param json
   * @returns {*}
   */
  static dataFromJson(json) {
    return json && json.data ? json.data : json;
  }

}
